// 物料包入口：注册全部首批物料，并按名导出定义与 schema。
import { registerMaterial } from './registry';
import { textMaterial } from './text';
import { imageMaterial } from './image';
import { shapeMaterial } from './shape';
import { buttonMaterial } from './button';
import { videoMaterial } from './video';
import { audioMaterial } from './audio';
import { formMaterial } from './form';
import { galleryMaterial } from './gallery';

export * from './registry';
export * from './meta';

export { textMaterial, TextPropsSchema, type TextProps } from './text';
export { imageMaterial, ImagePropsSchema, type ImageProps } from './image';
export { shapeMaterial, ShapePropsSchema, type ShapeProps } from './shape';
export { buttonMaterial, ButtonPropsSchema, type ButtonProps } from './button';
export { videoMaterial, VideoPropsSchema, type VideoProps } from './video';
export { audioMaterial, AudioPropsSchema, type AudioProps } from './audio';
export {
  formMaterial, FormPropsSchema, FormFieldSchema, FormFieldTypeSchema, validateForm,
  type FormProps, type FormField, type FormFieldType,
} from './form';
export { galleryMaterial, GalleryPropsSchema, type GalleryProps } from './gallery';

/** 全部物料，按物料库展示顺序排列。 */
export const ALL_MATERIALS = [
  textMaterial,
  imageMaterial,
  shapeMaterial,
  buttonMaterial,
  videoMaterial,
  audioMaterial,
  formMaterial,
  galleryMaterial,
];

for (const m of ALL_MATERIALS) registerMaterial(m);
